"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarcodeError = exports.BarcodeResponseSubcode = exports.BarcodeResponseCode = void 0;
var BarcodeResponseCode;
(function (BarcodeResponseCode) {
    BarcodeResponseCode["CREATED"] = "CREATED";
    BarcodeResponseCode["ERROR"] = "ERROR";
    BarcodeResponseCode["DELETED"] = "DELETED";
    BarcodeResponseCode["REACTIVATED"] = "REACTIVATED";
})(BarcodeResponseCode || (exports.BarcodeResponseCode = BarcodeResponseCode = {}));
var BarcodeResponseSubcode;
(function (BarcodeResponseSubcode) {
    BarcodeResponseSubcode["ALREADY_ASSIGNED"] = "ALREADY_ASSIGNED";
    BarcodeResponseSubcode["DUPLICATE"] = "DUPLICATE";
    BarcodeResponseSubcode["INVALID_BARCODE"] = "INVALID_BARCODE";
    BarcodeResponseSubcode["INVALID_TYPE"] = "INVALID_TYPE";
    BarcodeResponseSubcode["NO_BARCODE_SLOTS_REMAINING"] = "NO_BARCODE_SLOTS_REMAINING";
    BarcodeResponseSubcode["RESERVED_BY_ANOTHER_SELLER"] = "RESERVED_BY_ANOTHER_SELLER";
})(BarcodeResponseSubcode || (exports.BarcodeResponseSubcode = BarcodeResponseSubcode = {}));
var BarcodeError;
(function (BarcodeError) {
    BarcodeError["MULTIPLE_SELLER_IDS"] = "MULTIPLE_SELLER_IDS";
    BarcodeError["NOT_FOUND"] = "NOT_FOUND";
})(BarcodeError || (exports.BarcodeError = BarcodeError = {}));
//# sourceMappingURL=BarcodeResponse.js.map